import { ImageUrlsResized } from "./../models/images.model";

export function createSrcSet(imageUrlsResized: ImageUrlsResized) {
  return `${imageUrlsResized.s} 576w, ${imageUrlsResized.m} 768w, ${imageUrlsResized.l} 992w, ${imageUrlsResized.xl}`;
}
